export function GlobeSpinner() {
	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="relative h-32 w-32">
				<div className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-t-blue-500/50" />
				<div
					className="absolute inset-2 animate-spin rounded-full border-2 border-transparent border-t-blue-400/30"
					style={{ animationDirection: "reverse", animationDuration: "1.5s" }}
				/>
				<div className="absolute inset-4 rounded-full bg-gradient-to-br from-blue-900/20 to-transparent" />
			</div>
		</div>
	);
}
